const searchData = (state, action) => {
  if (!state) {
    return {
      [action.key]: {}
    }
  }
  switch (action.type) {
    case 'SEARCHINFO':
      return { ...state, [action.key]: action[action.key] }
    default:
      return state
  }
}

export default searchData


// WEBPACK FOOTER //
// ./src/reducer/search.js